const SET_LIST = (state, obj) => {
  state.list = obj
}

const REMOVE_ONE = (state, obj) => {
  state.list.splice(obj.index, 1)
}

export default {
  SET_LIST,
  REMOVE_ONE
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/minhasAnotacoes/store/mutations.js